const strings = {
    asanDarman: 'آسان درمان',
    mobile: 'شماره موبایل',
    activationCode: 'کد فعالسازی',
    name: 'نام',
    family: 'نام‌خانوادگی',
    nationalCode: 'کدملی',
    referralCode: 'کد معرف',
    login: 'ورود',
    orderDetail:'جزییات درخواست',
    orderRate:'بازخورد خدمات دهی',
    orderRateHint:'باز خورد خود را نسبت به خدمات ارائه شده, اعلام کنید',
    patientInformation:'اطلاعات مددجو',
    signup: 'ثبت نام',
    choiceCity:'انتخاب شهر',
    choiceArea:'انتخاب منطقه',
    area:'منطقه',
    messageText:'متن پیام',
    messageTitle:'موضوع پیام',
    addressName:'نام آدرس (خانه پدربزرگ یا ... )',
    relation:'نسبت',
    choiceSection:'انتخاب بخش',
    servants:'درمانگران',
    countSession:'تعداد جلسه',
    completeOrder:'تکمیل سفارش',
    favoritAddressInfo:'مشخصات آدرس منتخب',
    addFavoritAddressHint:'محل مورد نظرتان کجاست ؟',
    addFavoritPatient:'ثبت مددجوی منتخب',
    editFavoritPatient:'ویرایش مددجوی منتخب',
    chargeBalance:'شارژ حساب',
    chargeHint:'مبلغ به تومان وارد شود',
    rialUnit:'هزار تومان',
    walletBalance:'موجودی کیف پول',
    saveAndEdit:'ثبت و ویرایش اطلاعات',
    nameAndFamily:'نام و نام‌خانوادگی',
    choiceCityFirst:'شهر و منطقه خود را انتخاب نمایید',
    city:'شهر',
    address:'آدرسس',
    email:'ایمیل',
    phone:'تلفن ثابت',
    alley:'کوچه',
    wallet:'کیف پول',
    support:'پشتیبانی',
    adCode:'کد آد شما',
    houseNumber:'پلاک',
    description:'توضیحات',
    unit:'واحد',
    logout:'خروج از سیستم',
    rules:'قوانین و مقررات',
    aboutAd:'درباره آد',
    offers:'انتقادات و پیشنهادات',
    messageBox:'صندوق پیام',
    setting:'تنظیمات',
    favoritServant:'درمانگران منتخب',
    orderList:'لیست درخواست ها',
    profile:'اطلاعات کاربری',
    favoritPatient:'اشخاص منتخب',
    requestService:'درخواست خدمات',
    approveAndContinue:'تایید و ادامه',
    loginIfSignup: 'اگر قبلا ثبت نام کرده‌اید وارد شوید',
    sendCodeAgain: 'ارسال مجدد کد فعالسازی',
    second: 'ثانیه',
    choiceService:'انتخاب خدمت',
    enterAD: 'ورود به آد',
    signupAD: 'ثبت نام در آد',
    activateAccount: 'فعال سازی اکانت',
    codeActiveUntil: 'اعتبار کد تا',
    applyCode: 'تایید کد فعالسازی',
    sendActivateCode: 'ارسال کد فعالسازی',
    enterActiveCode: 'کد فعالسازی را وارد نمایید',
    notSignupYet: 'تاکنون ثبت نام نکرده‌ام',
    enterMobile: 'شماره همراه خود را برای دریافت کدفعالسازی وارد نمایید',
    mobileNotValid: 'شماره موبایل صحیح نمی باشد',
    codeNotValid: 'کد فعالسازی صحیح نمی باشد',
    balanceAccount: ' تومان (شارژ حساب)',
    searchLocationLabel:'محل مورد نظرتان کجاست؟',
    userLocation:'آدرس مددجو : ',
    approveAddress:'تایید آدرس و ادامه',
    fillAddress:'تکمیل آدرس مددجو',
    favoritAddress:'آدرس منتخب',
    favoritAddresses:'آدرس های منتخب',
    pleaseFillAddress:'لطفا آدرس دقیق مددجو را وارد کنید',
    choiceCityWarn:'لطفا شهر خود را انتخاب نمایید'
}
export default strings;
